import { clearImpersonation } from './impersonation';
import { storeSelectedCategory, storeSelectedCompetition } from '../Competition/selectedCompetition';
import { storeCategoryListFilters } from '../Competition/categoryListFilters';
import { storeWorkspaceTab } from '../Competition/workspaceTab';

const removeUserToken = () => {
    localStorage.removeItem('token');
    // The next person to log in on this browser is themselves.
    clearImpersonation();
    storeSelectedCompetition(null);
    storeSelectedCategory(null, null);
    storeCategoryListFilters([]);
    storeWorkspaceTab(null);
};

export default removeUserToken;
